//Global imports
import { useState } from 'react';

//Component imports
import { Layout } from '../../components/Layout';
import { DocumentTemplateList } from './Components';
import CreateTemplateModal from './Components/CreateTemplateModal';

const DocumentTemplate = () => {
    const [modalVisible, setModalVisible] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleTemplateCreated = () => {
        setRefreshKey((prev) => prev + 1);
    };

    return (
        <Layout>
            <DocumentTemplateList key={refreshKey} />
            <CreateTemplateModal
                visible={modalVisible}
                onClose={() => setModalVisible(false)}
                onSuccess={handleTemplateCreated}
            />
        </Layout>
    );
};

export default DocumentTemplate;
